/**
 * PostgREST API
 * This is a dynamic API generated by PostgREST
 *
 * The version of the OpenAPI document: 11.2.0 (c820efb)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EventContact { 
    /**
     * Note: This is a Foreign Key to `golf_event.id`.<fk table=\'golf_event\' column=\'id\'/>
     */
    golf_event_id: string;
    email: string;
    /**
     * Note: This is a Primary Key.<pk/>
     */
    id: string;
    name?: string;
    phone?: string;
    created_at: string;
    invite_last_sent_at?: string;
    event_last_viewed_at?: string;
    email_last_viewed_at?: string;
}

